import { gql } from '@apollo/client';

const GET_FILE_UUID = gql`
  query GetFileUuid($input: GetFileUuidInput!) {
    getFileUuid(input: $input)
  }
`;

export { GET_FILE_UUID };
